export default {
  login: {
    title: 'Sign in',
    username: 'Username',
    password: 'Password',
    login: 'Sign in',
    unknownError: 'An error occured. Please, try again later.',
    badCredentialsError: 'Invalid username or password.',
    forgotten: 'Forgotten password'
  },
  dashboard: {
    lastRecordings: 'Last recordings',
    moreRecordings: 'More recordings',
    SystemStorageUsage: 'Usage of system storage',
    logicStorageUsage: 'Storage usage',
    notifications: 'Notifications'
  },
  pageNotFound: {
    title: '404',
    pageNotFound: 'Page Not Found'
  },
  recordings: {
    recordingIsEncrypted: 'Recording is encrypted',
    downloadSelected: 'Download selected',
    play: 'Play',
    download: 'Download',
    downloadMetadata: 'Download metadata',
    archived: 'Recording is archived',
    delete: 'Delete recording',
    deleteSelected: 'Delete selected recordings',
    deletePrompt: 'To confirm recording deletion, enter word DELETE',
    deleteSelectedPrompt: 'To confirm deletion of selected recordings, enter DELETE SELECTED',
    downloading: 'Downloading recordings',
    requestDownload: 'Request download',
    requestPlay: 'Request play',
    requestDelete: 'Request deletion',
    actionRequest: 'Request action',
    requestQuestion: 'Do you want to request this operation?',
    reason: {
      unknown: 'No recording present.',
      timeMismatch: 'Outside of time window.',
      recordingDisabled: 'Recording is disasbled.',
      numberBlacklist: 'Number {number} is blacklisted.'
    },
    deleteFiltered: 'Delete all',
    deleteFilteredPrompt: 'If you really want to delete {number} recordings, that correspond to currently selected filters, enter DELETE FILTERED',
    deleting: 'Deleting'
  },
  profile: {
    loading: 'Loading profile',
    accesses: {
      title: 'Accesses'
    },
    certForm: {
      titleAdd: 'Add key',
      titleUpdate: 'Edit key'
    },
    certs: {
      title: 'Keys',
      noCerts: 'No keys'
    },
    common: {
      title: 'General settings',
      saved: 'Data saved'
    },
    password: {
      title: 'Change password',
      saved: 'New password saved',
      originalPassword: 'Current password',
      newPassword: 'New password',
      newPasswordAgain: 'Confirm new password',
      passwordsMustMatch: 'Passwords have to match',
      wrongOriginalPassword: 'Invalid current password'
    }
  },
  user: {
    passwordsMustMatch: 'Passwords have to match',
    passwordIsTooWeak: 'Heslo je příliš slabé'
  },
  configuration: {
    basic: {
      title: 'Configuration',
      maxAge: 'Maximum age of recordings',
      maxAgeHint: 'Number of days, set to 0 to never delete recordings',
      encrypt: 'Encrypt recordings',
      publicKey: 'Change public key',
      encryption: {
        none: 'None',
        password: 'Password',
        key: 'Key'
      },
      compression: 'Komprese',
      compressions: {
        pcm: 'PCM (Žádná)',
        flac: 'FLAC',
        mp3: 'MP3'
      },
      invalidKey: 'Invalid PGP key',
      insertIdent: 'Insert indentification of downloaded recording',
      saved: 'Configuration saved'
    },
    certs: {
      title: 'Enabled user keys',
      noCerts: 'No keys',
      addKey: {
        title: 'Add key',
        certificate: 'Key'
      }
    }
  },
  keyFoot: {
    keyWarning: 'You have private key saved in memory.',
    keyAndPassWarning: 'You have private key and password saved in memory!',
    forget: 'Forget'
  },
  player: {
    title: 'Player',
    titlePrivateKeySettings: 'Private key settings',
    titlePrivateKeyPass: 'Key password',
    privateKeyPrompt: 'This recording is encrypted. You need private key to decrypt it:',
    privateKey: 'Private key',
    saveLocally: 'Save locally to reuse',
    continue: 'Continue',
    passPrompt: 'Enter password for your private key to decrypt:',
    passphrase: 'Password',
    saveTemporary: 'Save temporarily',
    decrypt: 'Decrypt',
    forgetKey: 'Forget the key',
    download: 'Download',
    keyLoadingFailed: 'Key can not be loaded',
    keyRequiresPass: 'Key requires password',
    wrongPass: 'Wrong password',
    loadingFailed: 'Recording can not be loaded',
    wrongKey: 'Recording can not be decrypted using this key',
    decryptingInProgress: 'Recording is being decrypted',
    playError: 'There was error when loading recording. Does your browser support playing {0} recordings?'
  },
  tagger: {
    title: 'Tags',
    addTag: 'Add tag',
    add: 'Add'
  },
  reset: {
    success: 'Password was successfully changed.',
    continue: 'Continue',
    invalidToken: 'Password request was not found'
  },
  forgotten: {
    description: 'Please enter your username. You will receive e-mail with instructions.',
    success: 'E-mail sent, continue according to instructions in e-mail.',
    send: 'Send'
  },
  crud: {
    add: 'Add',
    filters: 'Filters',
    csv: 'CSV',
    delete: 'Delete',
    edit: 'Edit',
    deleteSelected: 'Delete selected',
    filter: {
      clear: 'Clear'
    },
    filterTooltip: '<b>Active filter:</b> {0}',
    refresh: 'Refresh',
    newTitle: 'Creating new item',
    editTitle: 'Editing existing item'
  },
  logicStorageReport: {
    displayFilters: 'Display filters',
    showOnly: 'Show only this item'
  },
  companySetup: {
    description: 'To continue, you need to setup a master public key for encryption of recording',
    publicKey: 'Master public key'
  },
  delegations: {
    title: 'Delegations',
    delegatedAs: 'Delegated as',
    expiredAlert: 'Your currently selected delegation expired.'
  },
  errors: {
    notEmpty: 'Can not be empty',
    mustBeLonger: 'Must be longer than {0}',
    passwordComplexityIsLessThanCompanyGroup: 'Password strength is smaller than password strength required by group',
    passwordExpiryIsLessThanCompanyGroup: 'Password expiry is bigger than password expiry set in group ({0} days)',
    invalidAutomaticIdent: 'Can only contain characters 1234567890+*#',
    positiveNumbersOnly: 'Only numbers >= 0'
  },
  titles: {
    login: 'Sign In',
    dashboard: 'Dashboard',
    recordings: 'Recordings',
    reports: {
      title: 'Reports',
      accesses: 'Login log',
      dataChanges: 'Changes log',
      systemStorage: 'System storage usage',
      logicStorage: 'Storage usage',
      notifications: 'Notifications'
    },
    admin: {
      title: 'Administration',
      superadmins: 'Superadministrators',
      groupadmins: 'Administrators',
      companyadmins: 'Company administrators',
      users: 'Users',
      companies: 'Companies',
      companyGroups: 'Company groups',
      lines: 'Lines',
      lineGroups: 'Line groups',
      numbers: 'Numbers',
      tags: 'Tags',
      configuration: 'Recording configuration',
      userCertificates: 'User certificates',
      companyDelegations: 'Delegations'
    },
    profile: 'Profile',
    logout: 'Sign out',
    passwordReset: 'Reset password',
    forgottenPassword: 'Forgotten password',
    companySetup: 'Recordings encryption settings'
  },
  headers: {
    user: 'User',
    ipAddress: 'IP address',
    loggedIn: 'Signed in',
    loggedOut: 'Signed out',
    changeDate: 'Date of change',
    tableName: 'Table',
    operation: 'Operation',
    dataBefore: 'Original data',
    dataAfter: 'Changed data',
    name: 'Name',
    description: 'Description',
    ico: 'Organization ID',
    enabled: 'Active',
    company: 'Company',
    companies: 'Companies',
    recordDaysOfWeek: 'Record in days',
    recordTimeFrom: 'Record from',
    recordTimeTill: 'Record to',
    recordingType: 'Record',
    certificates: 'Keys',
    phoneNumber: 'Number',
    targetGroup: 'Group',
    overrideGroup: 'Override group settings',
    username: 'Username',
    personName: 'Name',
    surname: 'Surname',
    email: 'E-mail',
    companyGroup: 'Company group',
    companyGroups: 'Company groups',
    password: 'Password',
    passwordAgain: 'Confirm password',
    browser: 'Browser',
    target: 'Line',
    targetGroups: 'Line groups',
    callDate: 'Date',
    source: 'Caller',
    destination: 'Callee',
    duration: 'Call duration',
    direction: 'Call direction',
    state: 'State',
    tags: 'Tags',
    targets: 'Lines',
    admins: 'Administrators',
    date: 'Date',
    actionType: 'Action',
    recordAlways: 'Always record',
    createAdmin: 'Create company admin',
    sendInfo: 'Send info by e-mail',
    quota: 'Space quota',
    passwordComplexity: 'Required password strength',
    passwordExpiry: 'Password expiration time',
    allowRecordingDeletion: 'Allow users to delete recordings',
    automaticIdent: 'Automatic identification',
    customLogo: 'Custom logo',
    customLogoHint: 'URL address of company logo',
    customCss: 'Vlastní styl',
    customCssHint: 'URL address of company css style',
    show: 'Show',
    totalSpace: 'Total space',
    takenSpace: 'Used',
    disabledSpace: 'Disabled',
    severity: 'Severity',
    type: 'Type',
    text: 'Text',
    maxChannels: 'Maximum number of channels',
    disableRecording: 'Disable recording',
    changePasswordAfterLogin: 'Force password change after login',
    requireEncryption: 'Require key encryption',
    recordingsSize: 'Used space',
    allowedHosts: 'Allow access from',
    allowedHostsHint: 'List of sources from which user can login. Empty list means any source is allowed. Format: mask;mask;mask. Mask is either hostname (example.com), ip address (192.168.100.1) or ip address with mask (192.168.100.0/24)',
    color: 'Color',
    dateFrom: 'Active from',
    delegationDuration: 'Duration',
    delegationDurationHint: 'In minutes',
    note: 'Note',
    recordingsConfirmations: 'Recordings confirmations',
    sipId: 'SIP Identificator',
    dtmfDelectionAllowed: 'Allow DTMF detection',
    companyAuditor: 'Auditor'
  },
  week: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  time: {
    from: 'From',
    to: 'To'
  },
  passwordComplexity: {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
  },
  recordingType: {
    always: 'Always record',
    never: 'Never record'
  },
  callDirection: {
    in: 'Incoming',
    out: 'Outgoing'
  },
  callState: {
    answered: 'Answered',
    notAnswered: 'Unanswered',
    busy: 'Busy'
  },
  space: {
    free: 'Free space',
    used: 'Used space',
    inactive: 'Used by inactive companies'
  },
  userRole: {
    superAdmin: 'Superadmin',
    groupAdmin: 'Admin',
    companyAdmin: 'Company admin',
    companyUser: 'User'
  },
  recordingRequests: {
    operation: {
      delete: 'Delete',
      play: 'Play',
      download: 'Download'
    }
  },
  companyNotifications: {
    severity: {
      debug: 'DEBUG',
      info: 'INFO',
      warn: 'WARNING',
      error: 'ERROR'
    },
    type: {
      automaticTarget: 'Automatic target',
      quotaUsage: 'Quota usage'
    },
    automaticTarget: 'Target with number {number} was created',
    quotaUsage: 'Disk usage has reached {percentage} % of quota'
  },
  targetsReport: {
    period: 'Period',
    defined: 'Defined',
    used: 'Used',
    title: 'Lines usage'
  },
  noItems: 'No items',
  loadingItems: 'Loading items',
  close: 'Close',
  save: 'Save',
  create: 'Create',
  savingFailed: 'Saving failed',
  cancel: 'Cancel',
  yes: 'Yes',
  no: 'No',
  inDays: 'In days',
  inMb: 'In MiB',
  changePasswordDescription: 'You need to set new password to finish logging in',
  search: 'Search'
}



// WEBPACK FOOTER //
// ./src/locale/en.js